import React from 'react';
import PropTypes from 'prop-types';
import { GridItem, Grid } from '@bnnvara/grids';
import { ClickWrapper } from '@/components/HeaderHero';
import * as S from './styled';

export const StatementHero = ({ data }) => {
  const { title, readMoreText, url, backgroundColor } = data;

  return (
    <ClickWrapper url={url} type="Statement" title={title}>
      <S.StatementHeroContainer backgroundColor={backgroundColor}>
        <Grid>
          <GridItem columnStartSm="1" columnEndSm="13">
            <S.StatementContent>
              <S.Title>{title}</S.Title>
              <S.Cta>{readMoreText}</S.Cta>
            </S.StatementContent>
          </GridItem>
        </Grid>
      </S.StatementHeroContainer>
    </ClickWrapper>
  );
};

StatementHero.propTypes = {
  data: PropTypes.shape({
    url: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    readMoreText: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string,
  }),
};
